export function cloudflareImage(path, params = {}) {
  if (Object.keys(params).length === 0) {
    return `https://cdn.appcheeta.com/${path}`;
  }
  const options = Object.keys(params)
    .map(key => `${key}=${params[key]}`)
    .join(",");
  return `https://cdn.appcheeta.com/cdn-cgi/image/${options}/${path}`;
}
